import { FC } from 'react';
import cn from 'classnames';

import { WebpImage, PriceComponent } from 'components/Shared/SharedComponents';
import { PsychicCardImage } from 'entities/PsychicCardImage';
import { StatusIndicatorWithText, PsychicNameWithIcon } from 'entities/JsxParserComponents';

import styles from './styles.module.scss';

import { IPsychicPhotoModule, ISelectionIcon } from '../config/declarations';
import { getRatePerMinute, getPsychicSelectionIcon } from '../lib';

/* Nested component */
const SelectionIcon: FC<ISelectionIcon> = ({ psychic, frame }) => {
  const selectionIcon = getPsychicSelectionIcon(psychic, frame);

  if (!selectionIcon) {
    return null;
  }

  const wrapperStyles = cn(
    styles.iconWrapper,
    {
      [styles.iconBlue]: psychic.isInCircle,
      [styles.iconRed]: psychic.isFavorite,
    },
  );

  return (
    <div className={wrapperStyles}>
      <WebpImage
        className={psychic.isFavorite ? styles.heartIcon : ''}
        image="external"
        src={selectionIcon}
      />
    </div>
  );
};

/* Main component */
const PhotoWithSelectionRate: FC<IPsychicPhotoModule> = ({
  src,
  psychic,
  imageClassName,
  psychicSkeleton,
}) => {
  const rates = getRatePerMinute(psychic);
  const labelIcon = psychicSkeleton?.labelsCollection?.items
    ?.find((item) => item?.slug === 'verification-icon');

  return (
    <div className={styles.photoWithRate}>
      <div className={styles.withSelection}>
        <div className={styles.imageWrapper}>
          <PsychicCardImage
            psychic={psychicSkeleton}
            image="external"
            src={src}
            alt={psychic.psychicName}
            className={cn(styles.image, imageClassName)}
          />
          <SelectionIcon psychic={psychic} frame={psychicSkeleton} />
        </div>
      </div>
      <div className={styles.stars}>
        <PsychicNameWithIcon
          psychicName={psychic.psychicName}
          image={labelIcon?.image!}
          wrapperClass={cn(styles.psychicName, styles.name)}
          className={styles.psychicIcon}
        />
      </div>
      <div className={styles.rateStatus}>
        <PriceComponent
          ratePerMinute={rates}
          ratePerMinuteText={psychicSkeleton.ratePerMinute}
        />
        <StatusIndicatorWithText
          chatStatus={psychic.chatStatus}
          phoneStatus={psychic.phoneStatus}
          wrapperClass={styles.status}
        />
      </div>
    </div>
  );
};

export default PhotoWithSelectionRate;
